import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IMenuItem } from '../../models/menu-item.model';

/**
 * Entrada del menu lateral.
 *
 * Dos formas posibles:
 *   · con `route`  → enlace navegable, marcado con `aria-current="page"`.
 *   · con `children` → grupo plegable (hoy el menu no usa esta rama, pero el
 *     modelo la contempla).
 *
 * En modo rail (sidebar colapsado) solo se ve el icono y la etiqueta se
 * muestra como tooltip propio, opaco: NO lleva `backdrop-filter` porque el
 * sidebar que lo contiene ya es una superficie de cristal.
 */
@Component({
  selector: 'app-menu-item',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
  readonly item = input.required<IMenuItem>();

  /** Sidebar colapsado: solo icono + tooltip. */
  readonly rail = input(false);

  /** Se emite al navegar; el drawer movil lo usa para cerrarse. */
  readonly navigated = output<void>();

  protected readonly expanded = signal(true);

  protected readonly children = computed(() => this.item().children ?? []);
  protected readonly hasChildren = computed(() => this.children().length > 0);

  protected toggle(): void {
    this.expanded.update((value) => !value);
  }

  protected onNavigate(): void {
    this.navigated.emit();
  }
}
